import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { getChildObject } from './form-data.utility';
import { startWith, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

export const filterEnergyStorageSystemsHook = (): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    const p = field.parent;
    const mfgObj = getChildObject(p, 'essManufacturer');
    const mfgFormField = field.form.get(mfgObj.key);

    const modelObj = getChildObject(p, 'essModel');

    field.props.options = mfgFormField.valueChanges.pipe(
      startWith(`${mfgFormField.value}:initial`),
      tap((value) => {
        if (field.form.status === 'DISABLED') {
          field.form.get(modelObj.key).disable();
        }
        if (field.form.status !== 'DISABLED') {
          const model = field.form.get(modelObj.key);
          const isStartValue =
            value === null ? false : value.toString().split(':').length > 1;
          if (!isStartValue) {
            model.setValue('');
          }
        }
      }),
      switchMap((mfg) => {
        if (mfg?.toString().includes(':initial')) {
          mfg = mfg.replace(':initial', '');
        }
        const filteredESSModels = field.options.formState.ess.filter(
          (essm) => essm.manufacturer === mfg
        );
        let options = filteredESSModels.map((essm) => {
          return {
            value: essm.modelNumber,
            label: essm.modelNumber,
          };
        });
        if (field.props?.allowOtherOption) {
          options = options.concat({
            value: 'Other',
            label: 'Other',
          });
        }
        return of(options);
      })
    );
  };
};
